import { render, staticRenderFns } from "./LandingPageEditor.vue?vue&type=template&id=efd799fe&"
import script from "./LandingPageEditor.vue?vue&type=script&lang=js&"
export * from "./LandingPageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports